import apiClient from "../api/client";
import {
  NutrigenUpcLink,
  NutrigenUpcLinkQuery,
  PagedResultDto,
  AddNutrigenUpcLinkDto,
  UpdateNutrigenUpcLinkDto
} from "../types/nutrigentypes";

export async function getPagedNutrigenUpcLinks(
  params: NutrigenUpcLinkQuery
): Promise<PagedResultDto<NutrigenUpcLink>> {
  const response = await apiClient.get<
    PagedResultDto<NutrigenUpcLink>
  >(
    "/api/nutrigen/upclinks",
    { params }
  );

  return response.data;
}

export async function addNutrigenUpcLink(
  dto: AddNutrigenUpcLinkDto
): Promise<void> {
  await apiClient.post(
    "/api/nutrigen/upclinks",
    dto
  );
}

export async function updateNutrigenUpcLink(
  upc: string,
  dto: UpdateNutrigenUpcLinkDto
): Promise<void> {
  await apiClient.put(
    `/api/nutrigen/upclinks/${upc}`,
    dto
  );
}